import { createSelector } from 'reselect';
import { currentUserRoleSelector, currentUserSelector } from '@selectors/user';
import { PagePermission, PermissionActions } from '@enums';
import { userHasPagePermission } from '@utils';

export const defaultDashboardRouteSelector = createSelector(
  [currentUserRoleSelector],
  (currentUserRole) => {
    if (
      !currentUserRole?.pagePermissions?.some(
        (pagePermission) =>
          (pagePermission.name === PagePermission.Management &&
            pagePermission[PermissionActions.View]) ||
          (pagePermission.name === PagePermission.Roles && pagePermission[PermissionActions.View])
      )
    ) {
      return null;
    }
    const childRoute = [PagePermission.Management, PagePermission.Roles].find((route) =>
      currentUserRole?.pagePermissions?.some(
        (pagePermission) => pagePermission[PermissionActions.View] && pagePermission.name === route
      )
    );

    if (!childRoute) {
      return null;
    }

    return `${PagePermission.Dashboard}/${childRoute}`;
  }
);

export const canAllowLettersPageSelector = createSelector(
  [currentUserSelector],
  (currentUserRole) =>
    userHasPagePermission(currentUserRole, [PagePermission.Letters], [PermissionActions.View])
);

export const canAllowSupportPageSelector = createSelector(
  [currentUserSelector],
  (currentUserRole) =>
    userHasPagePermission(currentUserRole, [PagePermission.Support], [PermissionActions.View])
);
